<template>
  <div class="insights-navigation-list-empty">
    <img
      :src="emptyListImg"
      :alt="`No ${resourceType} to display`"
    />
    <div class="insights-navigation-list-empty-title">{{ title }}</div>
    <div class="insights-navigation-list-empty-message">{{ message }}</div>
    <a
      :href="buttonLink"
      class="btn btn-primary"
    >
      {{ buttonLabel }}
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { OrganizationsResource, TeamsResource } from '~/resources';
import { IMAGE_EMPTY_BOX } from '~/rails_assets';

export default {
  name: 'InsightsNavigationListEmpty',
  props: {
    itemId: {
      type: String,
      default: '0',
    },
    type: {
      type: String,
      required: true,
    },
    individual: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['organizationId']),
    newTeamMemberLink() {
      return TeamsResource.addMembersLink({ id: this.itemId });
    },
    newTeamsLink() {
      return OrganizationsResource.newTeamLink({ id: this.organizationId });
    },
    emptyListImg() {
      return IMAGE_EMPTY_BOX;
    },
    resourceType() {
      return this.type === 'user' ? 'members' : 'teams';
    },
    title() {
      const individualMessage = !this.individual && this.type === 'user' ? ' other ' : ' ';

      return `No${individualMessage}${this.resourceType} to display`;
    },
    message() {
      const subject = this.type === 'user' ? 'team' : 'organization';

      return `Add ${this.resourceType} to your ${subject} to view metrics about their performance`;
    },
    buttonLabel() {
      return this.type === 'user' ? 'Add members' : 'Add team';
    },
    buttonLink() {
      return this.type === 'user' ? this.newTeamMemberLink : this.newTeamsLink;
    },
  },
};
</script>
